import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, createTextVNode as _createTextVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4fded1a3"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "os-modal__head"
};
const _hoisted_2 = {
  class: "os-modal__title"
};
const _hoisted_3 = {
  class: "os-modal__label"
};
const _hoisted_4 = {
  class: "os-modal__name text-truncate"
};
const _hoisted_5 = ["title"];
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ri-close-line"
}, null, -1));
const _hoisted_7 = [_hoisted_6];
const _hoisted_8 = ["src"];
const _hoisted_9 = {
  class: "an-modal-content"
};
const _hoisted_10 = ["innerHTML"];
const _hoisted_11 = {
  key: 0,
  class: "mt-3"
};
const _hoisted_12 = {
  class: "fw-semibold small mb-2"
};
const _hoisted_13 = {
  class: "an-files"
};
const _hoisted_14 = ["title", "onClick"];
const _hoisted_15 = ["onClick"];
const _hoisted_16 = {
  class: "an-file__actions"
};
const _hoisted_17 = ["title", "onClick"];
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ri-eye-line"
}, null, -1));
const _hoisted_19 = [_hoisted_18];
const _hoisted_20 = ["title", "onClick"];
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ri-download-2-line"
}, null, -1));
const _hoisted_22 = [_hoisted_21];
const _hoisted_23 = {
  key: 1,
  class: "mt-3"
};
const _hoisted_24 = ["href"];
const _hoisted_25 = {
  class: "os-modal__actions"
};
const _hoisted_26 = {
  key: 0,
  class: "an-modal-counter"
};
const _hoisted_27 = {
  key: 1,
  class: "os-status os-status--success"
};
const _hoisted_28 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ri-check-double-line"
}, null, -1));
const _hoisted_29 = ["disabled"];
const _hoisted_30 = {
  key: 0,
  class: "spinner-border spinner-border-sm"
};
const _hoisted_31 = {
  key: 1,
  class: "ri-check-line"
};
import { computed, ref } from 'vue';
import { extensionIcon } from '@/helpers/extensionsIcon';
import ViewFileModal from '@/views/invoices/components/viewFileModel.vue';
export default {
  __name: 'AnnouncementDetailContent',
  props: {
    announcement: {
      type: Object,
      required: true
    },
    isAcknowledging: {
      type: Boolean,
      default: false
    },
    acknowledged: {
      type: Boolean,
      default: false
    },
    counterText: {
      type: String,
      default: ''
    }
  },
  emits: ['close', 'acknowledge'],
  setup(__props) {
    const props = __props;
    const priorityIcon = computed(() => {
      const map = {
        critical: 'ri-alarm-warning-line',
        important: 'ri-error-warning-line',
        info: 'ri-information-line'
      };
      return map[props.announcement.priority] ?? 'ri-price-tag-3-line';
    });
    const previewOpen = ref(false);
    const previewUrl = ref('');
    const openAttachment = att => {
      previewUrl.value = att.url;
      previewOpen.value = true;
    };
    const downloadAttachment = att => {
      const link = document.createElement('a');
      link.href = att.url;
      link.download = att.name;
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      link.click();
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("header", _hoisted_1, [_createElementVNode("span", {
        class: _normalizeClass(["os-modal__icon", {
          'os-modal__icon--danger': __props.announcement.priority === 'critical'
        }])
      }, [_createElementVNode("i", {
        class: _normalizeClass(priorityIcon.value)
      }, null, 2)], 2), _createElementVNode("div", _hoisted_2, [_createElementVNode("span", _hoisted_3, _toDisplayString(__props.announcement.priority_label ?? __props.announcement.priority), 1), _createElementVNode("span", _hoisted_4, _toDisplayString(__props.announcement.title), 1)]), _createElementVNode("button", {
        type: "button",
        class: "os-iconbtn",
        title: _ctx.$t('common.close') || 'Close',
        onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('close'))
      }, _hoisted_7, 8, _hoisted_5)]), __props.announcement.cover_image ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        src: __props.announcement.cover_image,
        class: "an-modal-cover",
        alt: ""
      }, null, 8, _hoisted_8)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", {
        class: "announcement-body-html",
        innerHTML: __props.announcement.body
      }, null, 8, _hoisted_10), __props.announcement.attachments?.length ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.$t('announcements.viewAttachments')), 1), _createElementVNode("ul", _hoisted_13, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.announcement.attachments, att => {
        return _openBlock(), _createElementBlock("li", {
          key: att.url,
          class: "an-file"
        }, [_createElementVNode("button", {
          type: "button",
          class: "an-file__icon",
          title: _ctx.$t('common.view'),
          onClick: $event => openAttachment(att)
        }, [_createElementVNode("i", {
          class: _normalizeClass(_unref(extensionIcon)(att.name))
        }, null, 2)], 8, _hoisted_14), _createElementVNode("button", {
          type: "button",
          class: "an-file__name",
          onClick: $event => openAttachment(att)
        }, _toDisplayString(att.name), 9, _hoisted_15), _createElementVNode("div", _hoisted_16, [_createElementVNode("button", {
          type: "button",
          class: "an-file__action",
          title: _ctx.$t('common.view'),
          onClick: $event => openAttachment(att)
        }, _hoisted_19, 8, _hoisted_17), _createElementVNode("button", {
          type: "button",
          class: "an-file__action",
          title: _ctx.$t('common.download'),
          onClick: $event => downloadAttachment(att)
        }, _hoisted_22, 8, _hoisted_20)])]);
      }), 128))])])) : _createCommentVNode("", true), __props.announcement.cta ? (_openBlock(), _createElementBlock("div", _hoisted_23, [_createElementVNode("a", {
        href: __props.announcement.cta.url,
        target: "_blank",
        rel: "noopener noreferrer",
        class: "os-btn os-btn--primary"
      }, _toDisplayString(__props.announcement.cta.label), 9, _hoisted_24)])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_25, [__props.counterText ? (_openBlock(), _createElementBlock("small", _hoisted_26, _toDisplayString(__props.counterText), 1)) : _createCommentVNode("", true), __props.acknowledged ? (_openBlock(), _createElementBlock("span", _hoisted_27, [_hoisted_28, _createTextVNode(_toDisplayString(_ctx.$t('announcements.acknowledgedCount')), 1)])) : (_openBlock(), _createElementBlock("button", {
        key: 2,
        disabled: __props.isAcknowledging,
        class: "os-btn os-btn--primary",
        type: "button",
        onClick: _cache[1] || (_cache[1] = $event => _ctx.$emit('acknowledge'))
      }, [__props.isAcknowledging ? (_openBlock(), _createElementBlock("span", _hoisted_30)) : (_openBlock(), _createElementBlock("i", _hoisted_31)), _createTextVNode(" " + _toDisplayString(_ctx.$t('announcements.acknowledge')), 1)], 8, _hoisted_29))]), _createVNode(ViewFileModal, {
        modelValue: previewOpen.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => previewOpen.value = $event),
        attachment: previewUrl.value
      }, null, 8, ["modelValue", "attachment"])], 64);
    };
  }
};